// Hook pour gérer l'authentification JWT
import { useState, useEffect } from 'react'

// URL absolue du backend Lambda (force les appels en production)
const LAMBDA_API_BASE = 'https://lrv7zfe6dc7hrpucp3qulxlzaq0fszlw.lambda-url.eu-west-3.on.aws'

export function useAuth() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('access_token')
    const email = localStorage.getItem('email')
    const userId = localStorage.getItem('user_id')
    
    if (token && email) {
      setUser({ email, token, id: userId })
    }
    setLoading(false)
  }, [])

  const logout = () => {
    // Nettoyer complètement le localStorage
    localStorage.removeItem('access_token')
    localStorage.removeItem('token_type')
    localStorage.removeItem('email')
    localStorage.removeItem('user_id')
    localStorage.removeItem('refresh_token')
    
    // Nettoyer aussi les données de cache des permissions/nudges
    localStorage.removeItem('nudge_last_date')
    localStorage.removeItem('nudge_count')
    
    // Réinitialiser l'état utilisateur
    setUser(null)
    
    // Rediriger vers la page de connexion
    window.location.href = '/login'
  }

  const isAuthenticated = () => {
    return !!localStorage.getItem('access_token')
  }

  const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token')
    const rawType = localStorage.getItem('token_type') || 'Bearer'
    const tokenType = /^bearer$/i.test(rawType) ? 'Bearer' : rawType
    
    if (!token) return {}
    
    return {
      'Authorization': `${tokenType} ${token}`
    }
  }

  return {
    user,
    loading,
    logout,
    isAuthenticated,
    getAuthHeaders
  }
}

// Fonction utilitaire pour faire des appels API authentifiés
export async function authenticatedFetch(url, options = {}) {
  // Réécrire les chemins /api/... vers la base Lambda quand c'est un endpoint géré là-bas
  let fullUrl = url
  if (typeof url === 'string') {
    if (url.startsWith('/api/auth')) {
      fullUrl = `${LAMBDA_API_BASE}/auth${url.slice('/api/auth'.length)}`
    } else if (url.startsWith('/api/perms')) {
      fullUrl = `${LAMBDA_API_BASE}/perms${url.slice('/api/perms'.length)}`
    } else if (url.startsWith('/api/memory')) {
      fullUrl = `${LAMBDA_API_BASE}/memory${url.slice('/api/memory'.length)}`
    }
  }

  const token = localStorage.getItem('access_token')
  const rawType = localStorage.getItem('token_type') || 'Bearer'
  const tokenType = /^bearer$/i.test(rawType) ? 'Bearer' : rawType
  
  if (!token) {
    // Rediriger vers la page de connexion si pas de token
    window.location.href = '/login'
    throw new Error('No authentication token found')
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `${tokenType} ${token}`,
    ...options.headers
  }

  const response = await fetch(fullUrl, {
    ...options,
    headers
  })

  // Si le token est expiré ou invalide (401), déconnecter l'utilisateur
  if (response.status === 401) {
    localStorage.removeItem('access_token')
    localStorage.removeItem('token_type')
    localStorage.removeItem('email')
    localStorage.removeItem('user_id')
    localStorage.removeItem('refresh_token')
    window.location.href = '/login'
    throw new Error('Authentication token expired')
  }

  return response
}
